import classnames from 'classnames';
import { generateCompStylers } from '../../../../../../common/utils/styles';
import css from './Elements.module.scss';
import { Tooltip, svgSprite } from '../../../../../../hybrid/wrappers';
import { getIsCoupleVariation } from '../../../helpers';
import FromInputTitle from '../../../FormFieldTitle/FormFieldTitle';
import T from '../../../../../../common/components/T';
import OptionTitle from '../OptionTitle/OptionTitle';
import FromControl from '../../../FromControl/FromControl';
import { getIdetify, getOptionsToCopy } from '../../helpers';
import CopyType from '../../../form-input/components/CopyType/CopyType';

const DropdownSwitcher = (props) => {
    const {
        hint,
        placeholder,
        required,
        disabled,
        title,
        compStyle = {},
        errors,
        message,
        search,
        copy,
        buttons = {},
        keyword,
        changeHandler,
        variationStyle,
        val,
        isFilled,
        menuIsOpen,
        multiple,
        selectedLimit,
        valueOption,
        formatter,
        searchValue,
        selectHandler,
        variation,
        inputConfig,
        inputRef,
        selectAll,
        allSelected,
        previous,
        value
    } = props;
    const { stylers, classes } = generateCompStylers(compStyle);
    const maxContainerWidth = `calc(100% - ${Object.keys(buttons).length * 36}px)`;
    switch (keyword) {
        case 'search':
            if (search) {
                return (
                    <div
                        onClick={search?.onClick}
                        style={stylers.search}
                        className={classnames(css.formControlIconWrap, classes.search)}
                    >
                        {svgSprite(search?.icon || 'search', {
                            style: stylers.icon,
                            className: classnames(css.formControlSearchIconSvg, classes.icon)
                        })}
                    </div>
                );
            } else {
                return null;
            }
        case 'input':
            return (
                <div
                    style={{ maxWidth: maxContainerWidth, ...stylers.formControlInner }}
                    className={classnames(css.formControlInner, classes.formControlInner)}
                >
                    {!!title && getIsCoupleVariation(variationStyle) ? (
                        <FromInputTitle
                            errors={errors}
                            title={title}
                            compStyle={compStyle}
                            hint={hint}
                            required={required}
                            isFilled={Boolean(isFilled)}
                            variationStyle={variationStyle}
                            focused={menuIsOpen}
                        />
                    ) : null}
                    <div
                        className={classnames(css.formDropdownControl, multiple ? css.formDropdownControlMultiple : '', {
                            [css.formHiddenInput]: !menuIsOpen && !Boolean(isFilled)
                        })}
                    >
                        {isFilled ? (
                            multiple && val?.length ? (
                                val?.length > selectedLimit ? (
                                    <div className={classnames(css.formSelectMultiValue)}>
                                        <div className={css.formSelectMultiValueLabel}>
                                            {allSelected && selectAll ? (
                                                selectAll
                                            ) : (
                                                <>
                                                    <T textName='selected' defaultStr='Выбрано' page='all' />: {val.length}
                                                </>
                                            )}
                                        </div>
                                        <div>
                                            {value?.length && value.some((i) => i?.disabled) ? null : (
                                                <div
                                                    onClick={() => {
                                                        changeHandler(multiple ? [] : false);
                                                    }}
                                                    className={classnames('disable-parent-event', css.formSelectMultiValueRemove)}
                                                >
                                                    {svgSprite('cross', {
                                                        width: '8px',
                                                        height: '8px',
                                                        fill: 'var(--whiteColor)'
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    valueOption?.map((item, index) => {
                                        return (
                                            <div
                                                className={classnames(
                                                    css.formSelectMultiValue,
                                                    valueOption?.length > 1 && css.formSelectMultiValueitem
                                                )}
                                                key={`item?.id_${getIdetify(item)}_${index}`}
                                            >
                                                {formatter ? (
                                                    formatter(
                                                        item,
                                                        { className: css.formSelectMultiValueLabel },
                                                        false,
                                                        searchValue
                                                    )
                                                ) : (
                                                    <div className={css.formSelectMultiValueLabel}>
                                                        <OptionTitle option={item} />
                                                    </div>
                                                )}
                                                {item?.disabled ? null : (
                                                    <div>
                                                        <div
                                                            onClick={() => {
                                                                selectHandler(item);
                                                            }}
                                                            className={classnames(
                                                                'disable-parent-event',
                                                                css.formSelectMultiValueRemove
                                                            )}
                                                        >
                                                            {svgSprite('cross', {
                                                                width: '8px',
                                                                height: '8px',
                                                                fill: 'var(--whiteColor)'
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })
                                )
                            ) : null
                        ) : null}
                        <FromControl
                            placeholder={placeholder}
                            compStyle={compStyle}
                            title={title}
                            variation={variation}
                            errors={errors}
                            hint={hint}
                            required={required}
                            val={isFilled || searchValue?.length}
                            focused={menuIsOpen}
                            disabled={disabled}
                            customCss={{
                                wrapper: multiple && val?.length ? css.controMultiWrapper : '',
                                inner: css.controlInner
                            }}
                        >
                            <input
                                {...inputConfig}
                                ref={inputRef}
                                className={classnames(inputConfig.className, css.searchInput)}
                            />
                            {!multiple && valueOption && !searchValue ? (
                                formatter ? (
                                    formatter(
                                        valueOption,
                                        {
                                            style: stylers.singleValue,
                                            className: classnames(css.input, css.singleValue, classes.singleValue)
                                        },
                                        false,
                                        searchValue
                                    )
                                ) : (
                                    <div
                                        style={stylers.singleValue}
                                        className={classnames(css.input, css.singleValue, classes.singleValue)}
                                    >
                                        <OptionTitle option={valueOption} />
                                    </div>
                                )
                            ) : null}
                        </FromControl>
                    </div>
                </div>
            );
        case 'copy':
            return copy ? (
                <CopyType copy={copy} message={message} val={getOptionsToCopy(valueOption)} compStyle={compStyle} />
            ) : null;
        default:
            if (buttons[keyword]) {
                const { stylersBtn, classesBtn } = generateCompStylers(compStyle?.[keyword], 'Btn');

                const btn = buttons[keyword];
                return (
                    <div
                        className={classnames('disable-parent-event', previous === 'input' ? css.buttonMlAuto : '')}
                        onClick={btn.handler}
                    >
                        <Tooltip
                            text={btn.hint}
                            compStyle={{
                                inner: {
                                    className: classnames(css.formControlIconWrap, css.hoverBtn, classesBtn.button),
                                    ...stylersBtn.button
                                }
                            }}
                        >
                            {btn.icon
                                ? svgSprite(btn.icon, {
                                      width: '20px',
                                      height: '20px',
                                      fill: 'var(--blackColor)',
                                      ...stylersBtn.icon,
                                      className: classesBtn.icon
                                  })
                                : btn.name}
                        </Tooltip>
                    </div>
                );
            }
            return null;
    }
};
export default DropdownSwitcher;
